<template lang="pug">
  div(v-if="userAchievementList")
    portal(to="pageTitle")
      span Редактировать пользователя

    v-container
      Settings(
        :clubID="userOne && userOne.club && userOne.club.id ? userOne.club.id : ''"

        @clubChanged="onClubChanged"
      )

      .mt-10

      Controls(
        :hasDelete="false"
        @save="onSave"
      )

      .mt-10

      Content(
        :desserts="userAchievementList"
        :userID="$route.params.id"
      )

</template>

<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import ListGQL from '@/graphql/private/UserAchievement/List.gql'
import UserOneGQL from '@/graphql/private/User/Get.gql'
import UserUpdate from '@/graphql/private/User/Update.gql'

export default {
  name: 'users__id',
  components: {
    Settings,
    Content,
    Controls,
  },
  mixins: [Mixin, notify],
  data() {
    return {
      routeId: this.$route.params.id,
    }
  },

  apollo: {
    userOne: {
      query: UserOneGQL,
      variables() {
        return {
          filter: {
            userID: this.routeId,
          },
        }
      },
    },
    userAchievementList: {
      query: ListGQL,
      variables() {
        return {
          filter: {
            userID: this.routeId,
            locale: 'ru',
          },
        }
      },
    },
  },
  methods: {
    async onSave() {
      try {
        await this.$apollo.mutate({
          mutation: UserUpdate,
          variables: {
            user: {
              ID: this.routeId,
              ClubID: this.clubID,
            },
          },
        })

        await this.$apollo.queries.userOne.refetch()
        this.imageFile = null

        this.notify({
          text: 'Пользователь обновлен!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },
  },
  watch: {
    userAchievementList(input) {
      if (!input) {
        this.$router.push({
          name: 'users__list',
        })
      }
      const pst = {
        ...input,
      }
      for (const field in pst) {
        this[field] = pst[field]
      }
      this.files = this.attachments
    },
  },
}
</script>
